import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ProjectState {
  // Spec/12 §12.13 lists `activeProject: Project | null` and `projects: Project[]`,
  // but spec/12 also states: "All server state lives in React Query. No server
  // data in Zustand." The TWO statements together resolve to: keep the *selection*
  // (which project is active) in Zustand; load the Project record and the
  // projects list via React Query. activeProjectId is a UI-state selector, not
  // a cache of server data.
  activeProjectId: string | null;
  setActiveProjectId(id: string | null): void;
  clear(): void;
}

export const useProjectStore = create<ProjectState>()(
  persist(
    (set) => ({
      activeProjectId: null,
      setActiveProjectId: (id) => set({ activeProjectId: id }),
      clear: () => set({ activeProjectId: null }),
    }),
    {
      name: 'ta_active_project',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
